// extracted by mini-css-extract-plugin
module.exports = {"imagePageWrapper":"style_imagePageWrapper__tdzS3"};